export {
  default as Content,
  displayConfiguration,
  type DisplayConfiguration
} from './Content';
